import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type EditIconProps = {
    color?: string
    size?: number
    className?: ClassName
    style?: React.CSSProperties
}

export function EditIcon({ className, style, size = 20, color = 'currentColor' }: EditIconProps): React.ReactElement {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            style={style}
            data-testid="editIcon"
        >
            <path
                d="M13.83 2.53001L2.56 13.8L2.01 18.34C1.95 18.84 2.09 19.29 2.4 19.6C2.71 19.91 3.16 20.05 3.66 19.99L8.2 19.44L19.47 8.17001C20.18 7.46001 20.18 6.30001 19.47 5.59001L18.34 4.46001L17.55 3.67001L16.42 2.54001C15.71 1.83001 14.55 1.83001 13.84 2.54001L13.83 2.53001ZM15.2 3.89001L16.26 4.95001L17.05 5.74001L18.11 6.80001L16.5 8.41001L14.87 6.78001L13.58 8.07001L15.21 9.70001L6.84 18.08L3.86 18.44C3.68 18.46 3.55 18.32 3.57 18.16L3.93 15.17L15.19 3.89001H15.2Z"
                fill={color}
            />
        </svg>
    )
}
